import { firestoreRef, functionsRef } from "api";

const examRef = firestoreRef.collection("exams");

export async function getExamById(id) {
  return (await examRef.doc(id).get()).data();
}

export async function getPaper(id) {
  return (await firestoreRef
    .collection("papers")
    .doc(id)
    .get()).data();
}

export async function getQuestionsForPaper(paperKey) {
  let x = await firestoreRef
    .collection("questions")
    .where("paperKeys", "array-contains", paperKey)
    .get();
  let res = {};
  for (let i = 0; i < x.docs.length; i++) {
    let data = x.docs[i].data();
    res[data["questionKey"]] = data;
  }
  return res;
}

export async function getGroupsForPaper(paperKey) {
  let x = await firestoreRef
    .collection("groups")
    .where("paperKeys", "array-contains", paperKey)
    .get();
  let res = {};
  for (let i = 0; i < x.docs.length; i++) {
    let data = x.docs[i].data();
    res[data["key"]] = data;
  }
  return res;
}

export async function submitExam(quizKey) {
  return await firestoreRef
    .collection("live_quiz")
    .doc(quizKey)
    .update({ completed: true });
}

export const getAppTime = functionsRef.httpsCallable("getServerTime");
